import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const PasswordSetTokensServiceContext = createContext(undefined)

const PasswordSetTokensServiceProvider = ({
  children,
  oauthApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={PasswordSetTokensServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/password_set_tokens`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

PasswordSetTokensServiceProvider.propTypes = {
  children: PropTypes.any,
  oauthApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const usePasswordSetTokensService = () => {
  const context = useContext(PasswordSetTokensServiceContext)
  if (context === undefined) {
    throw new Error('PasswordSetTokensServiceContext was not provided. Make sure your component is a child of the PasswordSetTokensServiceProvider.')
  }
  return context
}

export {PasswordSetTokensServiceProvider, usePasswordSetTokensService}
